import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { misc } from '../services/api';
import { Newspaper, ArrowRight, ExternalLink } from 'lucide-react';
import { PBB_LOGO } from '../constants/brand';
import AppImage from './AppImage';

const ago = (iso) => {
  const mins = Math.round((Date.now() - new Date(iso)) / 60000);
  if (Number.isNaN(mins)) return '';
  if (mins < 60) return `${Math.max(mins, 1)}m ago`;
  if (mins < 1440) return `${Math.round(mins / 60)}h ago`;
  return new Date(iso).toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
};

export const HomeNewsHeadlines = () => {
  const [items, setItems] = useState([]);
  useEffect(() => { misc.newsFeed().then(d => setItems(d.articles.slice(0, 4))).catch(() => {}); }, []);
  if (!items.length) return null;
  return (
    <div className="mt-8 text-left" data-testid="home-news-headlines">
      <div className="flex items-end justify-between gap-3 mb-3">
        <div>
          <div className="text-[11px] uppercase tracking-widest text-green-700 font-semibold inline-flex items-center gap-1.5"><Newspaper size={12}/> Community News</div>
          <h2 className="text-base md:text-lg font-bold text-neutral-900">Fresh headlines from Black media</h2>
        </div>
        <Link to="/news" data-testid="home-news-see-all" className="shrink-0 text-sm font-semibold text-green-700 hover:text-green-600 inline-flex items-center gap-1">
          See all news <ArrowRight size={14}/>
        </Link>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {items.map(a => (
          <a key={a.id} href={a.link} target="_blank" rel="noopener noreferrer" data-testid={`home-news-${a.id}`}
            className="group bg-white rounded-2xl overflow-hidden border border-neutral-200 shadow-sm hover:shadow-lg hover:-translate-y-0.5 transition-[transform,box-shadow] flex flex-col">
            <AppImage src={a.image} alt={a.title} rounded="none" fallbackSrc={PBB_LOGO} overlay={!!a.image} />
            <div className="p-3 flex-1 flex flex-col">
              <div className="text-[11px] text-green-700 font-semibold">{a.source} <span className="text-neutral-400 font-normal">· {ago(a.publishedAt)}</span></div>
              <div className="mt-1 text-sm font-semibold text-neutral-900 leading-snug line-clamp-3 group-hover:text-green-800">{a.title}</div>
              <div className="mt-auto pt-2 text-[11px] text-neutral-500 inline-flex items-center gap-1">Read story <ExternalLink size={11}/></div>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};
